import { StandardTextFieldProps } from '@material-ui/core';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';
import { MediaPickerOverlay } from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-overlay.component';
import { MediaPreview } from '~admin/view/components/ui/form/fields/media/media-preview/media-preview.component';
import { MediaType } from '~client/model/media-type';
import { Column } from '~common/components/column.component';
import { useModalControls } from '~common/hook/use-modal-controls';
import { useMutable } from '~common/hook/use-mutable';

interface Props extends FieldRenderProps<MediaData>, StandardTextFieldProps {
  label: string;
  mediaType: MediaType;
  onMediaSelected?: (media: MediaData | null) => void;
  disabled?: boolean;
  submitFailed?: boolean;
}

export const MediaInput: React.FunctionComponent<Props> = ({
  input,
  label,
  onMediaSelected,
  meta,
  mediaType,
  disabled,
  submitFailed,
}) => {
  const { value } = input;
  const [touched, setTouched] = useMutable<boolean>(false);
  const getError = (): boolean => (touched() || submitFailed) && meta.invalid;
  const [overlayShown, showOverlay, hideOverlay] = useModalControls(false);

  return (
    <Container>
      <MediaPreview
        media={value}
        mediaType={mediaType}
        label={label}
        error={getError()}
        disabled={disabled}
        onPreviewClick={(): void => {
          showOverlay();
          if (!touched()) {
            setTouched(true);
          }
        }}
      />
      {overlayShown && (
        <MediaPickerOverlay
          mediaType={mediaType}
          onMediaSelected={(media: MediaData): void => {
            hideOverlay();
            onMediaSelected(media);
          }}
          onCancel={hideOverlay}
        />
      )}
    </Container>
  );
};

const Container = styled(Column)`
  align-items: center;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-input.component.tsx